/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, g as getElement } from './index-ef0fa435.js';
import { i as isNumber } from './isNumber-f0cb5287.js';
import { i as isArray } from './isArray-ba17b1aa.js';
import './isObjectLike-0c552769.js';
import './global-3053f997.js';

const radioButtonCss = "slot-fb[hidden],slot[hidden]{display:initial !important}lar-button{margin:0.4rem 0}.radios{margin:0 1rem}";

const RadioButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.output = createEvent(this, "output", 7);
    this.request = createEvent(this, "request", 7);
    this.icon = 'device';
    this.color = 'primary';
    this.colorModal = undefined;
    this.colorInputs = undefined;
    this.colorIconSmall = undefined;
    this.hideTitles = undefined;
    this.supTitle = undefined;
    this.subTitle = undefined;
    this.log = false;
    this.mainTitle = undefined;
    this.nodeSize = 'default';
    this.loading = true;
    this.selected = undefined;
    this.radios = undefined;
  }
  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node');
    this.output.emit(); // get selected
    this.output.emit({ command: 'get_radio_list' });
  }
  /**
   * Larva error input
   */
  async error(data) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Input Larva event message (see abow)
   */
  async input(data) {
    if (isNumber(data)) {
      this.selected = data;
    }
    else if (isArray(data)) {
      this.radios = data;
    }
    if (this.radios !== undefined && this.selected !== undefined) {
      this.loading = false;
    }
  }
  selectOption(index) {
    this.loading = true;
    this.output.emit(index);
  }
  render() {
    const value = (this.radios !== undefined && this.selected !== undefined) ? this.radios[this.selected].name : '';
    const componentProps = {
      onSelectoption: (e) => this.selectOption(e.detail),
      disabled: this.loading,
      color: this.colorInputs || this.color,
      radios: this.radios,
      selected: this.selected
    };
    return [
      h("lar-node", { icon: this.icon, hideTitles: this.hideTitles, color: this.color, supTitle: this.supTitle, mainTitle: this.mainTitle, subTitle: this.subTitle, colorModal: this.colorModal, colorInputs: this.colorInputs, colorIconSmall: this.colorIconSmall, value: value, log: this.log, loading: this.loading, nodeSize: this.nodeSize, component: "lar-radio-button-content", componentProps: componentProps }, h("slot", null))
    ];
  }
  get el() { return getElement(this); }
};
RadioButton.style = radioButtonCss;

export { RadioButton as lar_radio_button };

//# sourceMappingURL=lar-radio-button.entry.js.map